import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { type SafeHtml } from '@angular/platform-browser';
import { AbstractSanitizePipe } from './abstract-sanitize-pipe';

@Pipe({
  name: 'sanitizeHtml',
})
export class SanitizeHtmlPipe extends AbstractSanitizePipe implements PipeTransform {
  transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
